import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss']
})
export class SpinnerComponent {
  @Input() size: 'xs' | 'sm' | 'md' | 'lg' = 'md';

  get spinnerSize(): string {
    switch (this.size) {
      case 'xs': return '1rem';
      case 'sm': return '2rem'; // igual al spinner-border-sm de Bootstrap
      case 'lg': return '6rem'; // personalizado
      default:    return '4rem'; // tamaño medio por defecto
    }
  }

}
